import { Observable } from 'rxjs/Observable';
import {
  RequestOptions,
  RequestOptionsArgs,
  ResponseContentType
} from '@angular/http';
import { Injectable } from '@angular/core';
import { Console } from '@angular/core/src/console';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams
} from '@angular/common/http';
import { Router } from '@angular/router';
import { SessionAnuglarService } from './session-anuglar.service';
import { Carregado } from './carregado';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import { debounceTime } from 'rxjs-compat/operator/debounceTime';

@Injectable()
export class CsiHttp {
  optionsNew;
  _console: Console = console;

  constructor (private backend: HttpClient, private router: Router, private carregado: Carregado) {
  }

  request(url, options?: RequestOptionsArgs): any {
    this.optionsNew = this.addToken(options);
    return this.backend.request(url, this.optionsNew)
    .catch((err: HttpErrorResponse) => {
      this.verifyUnauthorization(err);
      return new EmptyObservable<Response>();
    });
  }

  get(url, options?: RequestOptionsArgs): Observable<any> {
      this.carregado.add(url);
    this.optionsNew = this.addToken(options);
    return this.backend.get(url, this.optionsNew)
    .do(complete => {
        this.carregado.close();
    })
    .catch((err: HttpErrorResponse) => {
      this.verifyUnauthorization(err);
      this.carregado.close();
      return new EmptyObservable<Response>();
    });

  }


  getDownload(url, options?: RequestOptionsArgs): any {
      this.carregado.add(url);
    this.optionsNew = this.addToken(options, true);
    return this.backend.get(url, this.optionsNew)
    .do(complete => {
        this.carregado.close();
    })
    .catch((err: HttpErrorResponse) => {
      this.verifyUnauthorization(err);
      this.carregado.close();
      return new EmptyObservable<Response>();
    });

  }

  getIgnore(url, options?: RequestOptionsArgs): Observable<any> {
  this.optionsNew = this.addToken(options);
  return this.backend.get(url, this.optionsNew)
  .catch((err: HttpErrorResponse) => {
    this.verifyUnauthorization(err);
    return new EmptyObservable<Response>();
  });

}

  put(url, body: any, options?: RequestOptionsArgs): any {
    this.optionsNew = this.addToken(options);
    return this.backend.put(url, body, this.optionsNew)
    .catch((err: HttpErrorResponse) => {
      this.verifyUnauthorization(err);
      return new EmptyObservable<Response>();
    });

  }

	delete(url, options?: RequestOptionsArgs): any {
    this.optionsNew = this.addToken(options);
    return this.backend.delete(url, this.optionsNew)
    .catch((err: HttpErrorResponse) => {
      this.verifyUnauthorization(err);
      return new EmptyObservable<Response>();
    });

  }

  deleteWithBody(url, body: any, options?: RequestOptionsArgs): any {
    this.optionsNew = this.addTokenWithBody(options, body);
    return this.backend.delete(url, this.optionsNew)
    .catch((err: HttpErrorResponse) => {
      this.verifyUnauthorization(err);
      return new EmptyObservable<Response>();
    });

  }

  post(url: string, body: any, options?: RequestOptionsArgs): any {
    this.carregado.add(url);
    this.optionsNew = this.addToken(options);
    return this.backend.post(url, body, this.optionsNew)
    .timeout(100000)
    .do(complete => {
      console.log('Finalizado POST');
      this.carregado.close();
    },
    error => {
      console.log('Erro ao finalizar requisição POST', error);
    })
    .catch((err: HttpErrorResponse) => {
      console.log('Erro ao fazer requisição POST', err);
      this.carregado.close();
      this.verifyUnauthorization(err);
      return new EmptyObservable<Response>();
    });

  }

  postDownload(url: string, body: any, options?: RequestOptionsArgs): any {
    this.carregado.add(url);
    this.optionsNew = this.addToken(options, true);
    return this.backend.post(url, body, this.optionsNew)
    .timeout(500000)
    .do(complete => {
      this.carregado.close();
    },
    error => {
      console.log('Erro ao finalizar requisição POST', error);
    })
    .catch((err: HttpErrorResponse) => {
      console.log('Erro ao fazer requisição POST', err);
      this.carregado.close();
      this.verifyUnauthorization(err);
      return new EmptyObservable<Response>();
    });

  }

  postIgnore(url: string, body: any, options?: RequestOptionsArgs): any {
    this.optionsNew = this.addToken(options);
    return this.backend.post(url, body, this.optionsNew)
    .catch((err: HttpErrorResponse) => {
      this.verifyUnauthorization(err);
      return new EmptyObservable<Response>();
    });

  }

  private catchAuthError (self: CsiHttp) {
    // we have to pass HttpService's own instance here as `self`
    return (res: Response) => {
    //  console.log(res);
      if (res.status === 401 || res.status === 403) {
        // if not authenticated
        this.verifyUnauthorization(res.text);
      }
      return Observable.throw(res);
    };
  }

  verifyUnauthorization(err) {
    if (err.error instanceof Error) {
      // A client-side or network error occurred. Handle it accordingly.
   //   console.log('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (err.status === 401) {
        console.log('Finalizando com... 401');
        this.router.navigate(['/login'], { skipLocationChange: true });
      }
    }
  }
  addTokenWithBody(options: RequestOptionsArgs, body: any): RequestOptionsArgs {
    let optionsNew;
    let headersNew;

    if (options) {
      optionsNew = options;
      if (options.headers) {
        options.headers.set(
          'Authorization',
          'Bearer ' + SessionAnuglarService.getToken(),
        );
        options.headers.set(
          'body',
          body
        );
      } else {
        headersNew = new HttpHeaders({
          Authorization: 'Bearer ' + SessionAnuglarService.getToken(),
          body: body
        });
    //    this._console.log(headersNew.has('Authorization'));
        options.headers = headersNew;
      }
    } else {
      headersNew = new HttpHeaders({
        Authorization: 'Bearer ' + SessionAnuglarService.getToken(),
        body: body
      });
      optionsNew = new RequestOptions({
        headers: headersNew
      });
    }

    return optionsNew;
  }
  addToken(options: RequestOptionsArgs, isBlob = false): RequestOptionsArgs {
    let optionsNew;
    let headersNew;

    if (options) {
      optionsNew = options;
      if (options.headers) {
        options.headers.set(
          'Authorization',
          'Bearer ' + SessionAnuglarService.getToken()
        );
      } else {
        headersNew = new HttpHeaders({
          Authorization: 'Bearer ' + SessionAnuglarService.getToken()
        });
    //    this._console.log(headersNew.has('Authorization'));
        options.headers = headersNew;
      }
    } else {
      headersNew = new HttpHeaders({
        Authorization: 'Bearer ' + SessionAnuglarService.getToken()
      });
      optionsNew = new RequestOptions({
        headers: headersNew
      });
    }

    if (isBlob) {
      optionsNew.responseType = 'Blob';
    }

    return optionsNew;
  }

  public converterFiltroParaHttpParam(filter: any, params?: HttpParams): HttpParams {
    if (!params) {
      params = new HttpParams();
    }
    if (filter) {
      Object.keys(filter).forEach(key => {
        params = params.append(key, filter[key]);
      });
    }
    return params;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/core/csi-http.ts